const UNIT_MS = {
  ms: 1,
  s: 1_000,
  m: 60_000,
  h: 3_600_000,
  d: 86_400_000,
};

const parseOne = (raw) => {
  if (!raw?.trim()) return null;
  const match = /^(\d+(?:\.\d+)?)\s*(ms|s|m|h|d)?$/i.exec(raw.trim());
  if (!match) return null;
  const amount = Number(match[1]);
  const unit = (match[2] ?? "ms").toLowerCase();
  const mult = UNIT_MS[unit];
  if (!Number.isFinite(amount) || mult == null) return null;
  return amount * mult;
};

export const parseIdleTimeoutMs = (value, fallback) => {
  return parseOne(value) ?? parseOne(fallback) ?? 30 * 60_000;
};

/** Admin/doctor app client idle logout (default 30m). Set via REACT_APP_IDLE_TIMEOUT at build time. */
export const IDLE_TIMEOUT_MS = parseIdleTimeoutMs(
  process.env.REACT_APP_IDLE_TIMEOUT,
  "30m",
);
